//js实现unicode码字符串与utf8字节数据互转
/**
 * unicode string to utf-8
 * @param text 字符串
 * @returns {*} utf-8编码
 */
import pako from 'pako'

/**
* utf8 byte to unicode string
* @param utf8Bytes
* @returns {string}
*/

export function utf8ByteToUnicodeStr(utf8Bytes){
    var unicodeStr ="";
    for (var pos = 0; pos < utf8Bytes.length;){
        var flag= utf8Bytes[pos];
        var unicode = 0 ;
        if ((flag >>>7) === 0 ) {
            unicodeStr+= String.fromCharCode(utf8Bytes[pos]);
            pos += 1;

        } else if ((flag &0xFC) === 0xFC ){
            unicode = (utf8Bytes[pos] & 0x3) << 30;
            unicode |= (utf8Bytes[pos+1] & 0x3F) << 24;
            unicode |= (utf8Bytes[pos+2] & 0x3F) << 18;
            unicode |= (utf8Bytes[pos+3] & 0x3F) << 12;
            unicode |= (utf8Bytes[pos+4] & 0x3F) << 6;
            unicode |= (utf8Bytes[pos+5] & 0x3F);
            unicodeStr+= String.fromCodePoint(unicode) ;
            pos += 6;

        }else if ((flag &0xF8) === 0xF8 ){
            unicode = (utf8Bytes[pos] & 0x7) << 24;
            unicode |= (utf8Bytes[pos+1] & 0x3F) << 18;
            unicode |= (utf8Bytes[pos+2] & 0x3F) << 12;
            unicode |= (utf8Bytes[pos+3] & 0x3F) << 6;
            unicode |= (utf8Bytes[pos+4] & 0x3F);
            unicodeStr+= String.fromCodePoint(unicode) ;
            pos += 5;

        } else if ((flag &0xF0) === 0xF0 ){
            unicode = (utf8Bytes[pos] & 0xF) << 18;
            unicode |= (utf8Bytes[pos+1] & 0x3F) << 12;
            unicode |= (utf8Bytes[pos+2] & 0x3F) << 6;
            unicode |= (utf8Bytes[pos+3] & 0x3F);
            unicodeStr+= String.fromCodePoint(unicode) ;
            pos += 4;

        } else if ((flag &0xE0) === 0xE0 ){
            unicode = (utf8Bytes[pos] & 0x1F) << 12;;
            unicode |= (utf8Bytes[pos+1] & 0x3F) << 6;
            unicode |= (utf8Bytes[pos+2] & 0x3F);
            unicodeStr+= String.fromCharCode(unicode) ;
            pos += 3;

        } else if ((flag &0xC0) === 0xC0 ){ //110
            unicode = (utf8Bytes[pos] & 0x3F) << 6;
            unicode |= (utf8Bytes[pos+1] & 0x3F);
            unicodeStr+= String.fromCharCode(unicode) ;
            pos += 2;

        } else{
            unicodeStr+= String.fromCharCode(utf8Bytes[pos]);
            pos += 1;
        }
    }
    return unicodeStr;
}

var ver = "h1.0.0"

// 发送
export function sendText0(){
    var val = sendText.value;
    //加密
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(btoa(data));
    // sendText.value = "";
}

// 登录
export function login0(ws,user,pwd){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"conn","act":"login_pro","user":'+localStorage.getItem('arglogin')+',"ver":"'+ver+'","args":{"user":'+user+',"pwd":"'+window.btoa(pwd)+'"},"sign":"xxx","time":'+timestamp+',"no":123410}';

    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//查询账户信息
export function accountMsg(ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"user","act":"get_money_info","user":'+localStorage.getItem('arglogin')+',"args":null,"ver":"'+ver+'","sign":"xxx","time":'+timestamp+',"no":123411}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 订阅行情
export function get_all_symbols_quote(ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"quote","act":"get_all_symbols_quote","user":'+user+',"args":null,"sign":"xxx","time":'+timestamp+',"no":123456,"ver":"'+ver+'"}'
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 开启订阅行情报价功能
export function openhq(ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"sub","act":"sub_quote_update","user":'+user+',"args":null,"sign":"xxxxx","time":'+timestamp+',"no":123430,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 订阅所有品种行情报价
export function allhq(ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"sub","act":"sub_all_quote_update","user":'+user+',"args":null,"sign":"xxxxx","time":'+timestamp+',"no":123431,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 获取品类
export function getsymbol(ws){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"symbol","act":"get_enable","user":'+localStorage.getItem('arglogin')+',"args":null,"ver":"'+ver+'","sign":"xxx","time":'+timestamp+',"no":123488}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 获取黄金挂单距离
export function stopsLevelXAU(ws,symbol,user){
    var goldsymbol
    if(symbol == 'XAU'){
        goldsymbol = "'XAU'"
    }else if(symbol == 'GOLD'){
        goldsymbol = "'GOLD'"
    }
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"get_stop_level","user":'+localStorage.getItem('arglogin')+',"args":{"symbol":'+goldsymbol+'},"sign":"xxxxx","time":'+timestamp+',"no":123412,"ver":"'+ver+'"}';

    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 获取白银挂单距离
export function stopsLevelXAG(ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"get_stop_level","user":'+localStorage.getItem('arglogin')+',"args":{"symbol":"XAG"},"sign":"xxxxx","time":'+timestamp+',"no":123413,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//黄金市价下单
export function dealsj(symbol,op,volume,stoploss,takeprofit,price,expiration,ws,stoplimit,user){

    var timestamp = Date.parse(new Date())/1000;

    var val = '{"grp":"trade","act":"order_send","user":'+localStorage.getItem('arglogin')+',"args":{"symbol":"'+symbol+'","op":'+op+',"volume":'+volume+',"stoploss":'+stoploss+',"takeprofit":'+takeprofit+',"price":'+price+',"expiration":'+expiration+',"stoplimit":'+stoplimit+'},"sign":"xxx","time":'+timestamp+',"no":158598,"ver":"'+ver+'"}';

    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//白银市价下单
export function sldealsj(symbol,op,volume,stoploss,takeprofit,price,expiration,ws,stoplimit,user){
    
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"order_send","user":'+localStorage.getItem('arglogin')+',"args":{"symbol":"'+symbol+'","op":'+op+',"volume":'+volume+',"stoploss":'+stoploss+',"takeprofit":'+takeprofit+',"price":'+price+',"expiration":'+expiration+',"stoplimit":'+stoplimit+'},"sign":"xxx","time":'+timestamp+',"no":123415,"ver":"'+ver+'"}';

    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//查询所有持仓单
export function allholdmsg(ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"order","act":"get_open_orders","user":'+localStorage.getItem('arglogin')+',"args":{"ticket":null},"sign":"xxxxx","time":'+timestamp+',"no":123416,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 多单批量平仓(买单)
export function BuyPc(ws,user){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"close_all_buy_open_order","user":'+localStorage.getItem('arglogin')+',"args":null,"sign":"xxxxx","time":'+timestamp+',"no":123417,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//空单批量平仓(卖单)
export function SellPc(ws,user){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"close_all_sell_open_order","user":'+localStorage.getItem('arglogin')+',"args":null,"sign":"xxxxx","time":'+timestamp+',"no":123418,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//所有单平仓(平仓所有单)
export function AllPc(ws,user){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"close_all_open_order","user":'+localStorage.getItem('arglogin')+',"args":null,"sign":"xxxxx","time":'+timestamp+',"no":123419,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//平仓、分批平仓
export function batchPc(ticket,volume,ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"close_open_order","user":'+localStorage.getItem('arglogin')+',"args":{"ticket":'+ticket+',"volume":'+volume+'},"sign":"xxx","time":'+timestamp+',"no":123420,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 修改持仓
export function revisecc(tickets,openprices,stoplosss,takeprofits,expirations,ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"order_modify","user":'+localStorage.getItem('arglogin')+',"args":{"ticket":'+tickets+',"openprice":'+openprices+',"stoploss":'+stoplosss+',"takeprofit":'+takeprofits+',"expiration":'+expirations+'},"sign":"xxx","time":'+timestamp+',"no":123421,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//查询挂单页面所有挂单 查询所有委托单
export function allPendingOrder(ws,user){
    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"order","act":"get_pend_orders","user":'+localStorage.getItem('arglogin')+',"args":null,"sign":"xxxxx","time":'+timestamp+',"no":123422,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 撤单
export function handleChedan(ticket,ws,user){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"trade","act":"delete_pend_order","user":'+localStorage.getItem('arglogin')+',"args":{"ticket":'+ticket+'},"sign":"xxx","time":'+timestamp+',"no":123423,"ver":"'+ver+'"}';
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 修改挂单
export function reviseOrder(tickets,openprices,stoplosss,takeprofits,expirations,ws,changeorder,stoplimit){

    var timestamp = Date.parse(new Date())/1000;
    // var val = '{"grp":"trade","act":"order_modify","user":'+localStorage.getItem('arglogin')+',"args":{"ticket":'+tickets+',"openprice":'+openprices+',"stoploss":'+stoplosss+',"takeprofit":'+takeprofits+',"expiration":'+expirations+'},"sign":"xxx","time":17747561351,"no":123424}';
    var val2 = {"grp":"trade","act":"order_modify","user":localStorage.getItem("arglogin"),"args":{"ticket":tickets,"openprice":openprices,"stoploss":stoplosss,"takeprofit":takeprofits,"expiration":expirations,"stoplimit":stoplimit},"sign":"xxx","time":timestamp,"no":123424,"ver":ver};
    if(changeorder && takeprofits == null){
        val2.args.takeprofit = val2.args.takeprofit?val2.args.takeprofit:0
    }else if(!changeorder && takeprofits == null){
        delete val2.args.takeprofit;
    }
    // if(changeorder &&  expirations == null){
    //     val2.args.expiration = val2.args.expiration?val2.args.expiration:0
    // }else if(!changeorder &&  expirations == null){
    //     delete val2.args.expiration;
    // }
    if(changeorder && stoplosss == null){
        val2.args.stoploss = val2.args.stoploss?val2.args.stoploss:0
    }else if(!changeorder && stoplosss == null){
        delete val2.args.takeprofit;
    }

    var newstr=JSON.stringify(val2); 

    var data = pako.deflateRaw(newstr, { to: 'string' });
    ws.send(window.btoa(data));
}

// 历史持仓单
export function historycc(from,to,ws,user){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"order","act":"get_close_orders","user":'+localStorage.getItem('arglogin')+',"args":{"from":'+from+',"to":'+to+'},"sign":"xxxxx","time":'+timestamp+',"no":123425,"ver":"'+ver+'"}'
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

//所有失效单历史
export function allcdhistory(from,to,ws,user){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"order","act":"get_history_pend_orders","user":'+localStorage.getItem('arglogin')+',"args":{"from":'+from+',"to":'+to+'},"sign":"xxxxx","time":'+timestamp+',"no":123426,"ver":"'+ver+'"}'
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 所有资金明细
export function allmx(from,to,ws,user){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"order","act":"get_funded_orders","user":'+localStorage.getItem('arglogin')+',"args":{"from":'+from+',"to":'+to+'},"sign":"xxxxx","time":'+timestamp+',"no":123427,"ver":"'+ver+'"}'
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}

// 历史返点单
export function historyfd(from,to,ws,user){

    var timestamp = Date.parse(new Date())/1000;
    var val = '{"grp":"order","act":"get_fundeds_orders","user":'+localStorage.getItem('arglogin')+',"args":{"from":'+from+',"to":'+to+'},"sign":"xxxxx","time":'+timestamp+',"no":123428,"ver":"'+ver+'"}'
    var data = pako.deflateRaw(val, { to: 'string' });
    ws.send(window.btoa(data));
}


// WEBPACK FOOTER //
// ./src/utils/socket2.js